export default function useBulkEmailDocumentFormSteps({
  allData,
  initialInsuredIds,
  initialDocumentIds,
  initialDocuments
}) {
  const formSteps = [
    {
      name: 'Select Date',
      initialValues: {
        activeOn: '',
        initialData: allData,
        initialInsuredIds: initialInsuredIds || [],
        initialDocumentIds: initialDocumentIds || [],
        initialDocuments: initialDocuments || []
      }
    },
    {
      name: 'Include Stakeholder Documents',
      initialValues: { includeStakeholders: false }
    },
    {
      name: 'Select Documents',
      initialValues: {
        documentIds: initialDocumentIds || [],
        documentIdsFilteredByDate: initialDocumentIds || [],
        documentsFilteredByDate: initialDocuments || [],
        insuredIdsFilteredByDate: initialInsuredIds || []
      }
    },
    {
      name: 'Select Recipients',
      initialValues: {
        insuredIds: initialInsuredIds || [],
        insuredIdsFilteredByDocs: initialInsuredIds || []
      }
    },
    {
      name: 'Confirm Recipients',
      initialValues: {}
    }
  ];

  return { formSteps };
}
